import React from 'react';
import { useTranslations } from '@lang';
import { BasketRoomExtra } from 'shared-types/Room';
import { formatExtraLabel } from '@common/helpers/formatExtraLabel';
import { Price } from '../../../../Price/Price';
import { ExtraContainer, ExtraPrice, ExtraText } from './RoomExtra.styles';

type RoomExtraProps = {
  roomExtra: BasketRoomExtra;
};

export const RoomExtra: React.FC<RoomExtraProps> = ({ roomExtra: { name, quantity, price } }) => {
  const { t } = useTranslations();
  const label = formatExtraLabel(name, quantity, 'x');
  if (!label) return null;
  return (
    <ExtraContainer>
      <ExtraText>{label}</ExtraText>
      <ExtraPrice>
        {price && price?.amount > 0 ? <Price price={price} /> : t('room.extras.complimentary')}
      </ExtraPrice>
    </ExtraContainer>
  );
};
